import type { BookingContext } from './booking-context';

export function initCountdowns(context: BookingContext, callback: () => void) {
	// data-countdown
	// data-expires
	// data-now
	// for each of the countdowns, start a timeout that will update the countdown every second to the expiry time, offect by the current time in case there is a delay in the page loading

	const countdowns = context.root.querySelectorAll<HTMLElement>('[data-countdown]');

	countdowns.forEach((countdown) => {
		const expires = countdown.dataset.expires;
		const now = countdown.dataset.now;

		if (!expires || !now) {
			return;
		}

		const expiresDate = new Date(expires);

		const referenceTime = new Date(now);
		const nowTime = new Date();

		// Get the difference between the reference time and the current time
		const timeDiff = referenceTime.getTime() - nowTime.getTime();

		const updateTimer = () => {
			if (!countdown.isConnected) {
				clearInterval(interval);
				return;
			}

			const nowDate = new Date();

			const diff = -(nowDate.getTime() + timeDiff - expiresDate.getTime());

			if (diff <= 0) {
				clearInterval(interval);
				countdown.textContent = '00:00';
				callback();
				return;
			}

			const minutes = Math.floor(diff / 1000 / 60);
			const seconds = Math.floor((diff / 1000) % 60);

			countdown.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
		};

		const interval = setInterval(() => updateTimer(), 500);
		updateTimer();
	});
}
